// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"79389d7c","144":"e39ceb7b","389":"016e5bdc","443":"2b1ea1bb","657":"e39ceb7b","664":"e39ceb7b","814":"0ae81b83","828":"eea30f9b"}[chunkId] + ".chunk.css";
};